import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { Close } from "@mui/icons-material";
import { BIBlue } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import { toast } from "react-toastify";

const ReferralModal = (props) => {
  const [qrCodeValue, setQrCodeValue] = useState(null);

  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.BuilderNetwork || {};
  const { TEXT_LINK_COPIED = English.BuilderNetwork.TEXT_LINK_COPIED } = LanguageData || {};
  useEffect(() => {
    setQrCodeValueBasedOnDb();
  }, []);

  const setQrCodeValueBasedOnDb = useCallback(async () => {
    const value = `${import.meta.env.REACT_APP_WEB_USER}/refer/${loginData?.userInformation?.UserId}`;
    setQrCodeValue(value);
  }, []);

  let isSharing = false;

  const handleShareClick = () => {
    const value = `${import.meta.env.REACT_APP_WEB_USER}/refer/${loginData?.userInformation?.UserId}`;
    const message = `Check out BuildID today and become a part of a construction community that empowers and rewards you!\n${value}`;

    if (navigator.share) {
      if (isSharing) return;

      const shareData = {
        title: "BuildId Refer",
        text: message,
        url: value
      };

      isSharing = true;
      navigator
        .share(shareData)
        .catch((error) => console.error("handleShareClick-> Error In Navigator Share: ", error))
        .finally(() => {
          isSharing = false;
        });
    } else {
      // Fallback for browsers like Firefox: use mailto
      try {
        const subject = encodeURIComponent(
          "Check out BuildID today and become a part of a construction community that empowers and rewards you!"
        );
        const body = encodeURIComponent(message);
        const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;
        isSharing = false;
      } catch (error) {
        console.log("handleShareClick-> Error When Sharing (fallback): ", error);
      }
    }
  };

  return (
    <div>
      <Modal open={props?.open}>
        <Box
          className="client-modal-responsive"
          sx={{
            backgroundColor: props?.from == "home" ? BIBlue : "white"
          }}>
          <Box sx={{ flexGrow: 1, padding: "10px" }}>
            <Grid container>
              <Grid
                size={12}
                sx={{
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  display: "flex"
                }}>
                <Typography
                  variant="body1"
                  color={props?.from == "home" ? "white" : "black"}
                  style={{ textAlign: "center" }}>
                  {props?.TEXT_MASSAGE}
                </Typography>
                <IconButton
                  onClick={() => {
                    props?.onClose();
                  }}
                  sx={{ color: props?.from == "home" ? "white" : "black" }}>
                  <Close />
                </IconButton>
              </Grid>
            </Grid>
            {qrCodeValue && (
              <Stack
                style={{
                  margin: "15px auto",
                  maxWidth: 200,
                  width: "100%",
                  padding: "20px",
                  backgroundColor: "white",
                  borderRadius: "10px"
                }}>
                <QRCode size={256} style={{ width: "100%", height: "auto" }} value={qrCodeValue} />
              </Stack>
            )}
            <Grid container spacing={2} justifyContent={"center"}>
              <Grid size={6}>
                <Button
                  color={props?.from == "home" ? "inherit" : "primary"}
                  variant="contained"
                  style={{ width: "100%" }}
                  onClick={() => {
                    navigator.clipboard
                      .writeText(
                        `${import.meta.env.REACT_APP_WEB_USER}/refer/${loginData?.userInformation?.UserId}`
                      )
                      .then((res) => {
                        toast.info(TEXT_LINK_COPIED);
                      })
                      .catch((error) => {
                        console.error("onClick-> Error When Trying To Copy: ", error);
                      });
                  }}>
                  {props?.TEXT_COPY_LINK}
                </Button>
              </Grid>
              {props?.from == "home" ? null : (
                <Grid size={6}>
                  <Button
                    sx={{ backgroundColor: "#0826b8" }}
                    color="primary"
                    variant="contained"
                    style={{ width: "100%" }}
                    onClick={handleShareClick}>
                    {props?.TEXT_SHARE}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ReferralModal;
